import { ConfirmUnsaved } from "components/ConfirmDialog/ConfirmUnsaved";
import { HookFormDebug } from "components/FormDebug/HookFormDebug";
import { EditFormFooter } from "components/Forms/EditFormFooter";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { useEditAgendaItem } from "providers";
import { useTranslations } from "providers";
import React from "react";

import { EditAgendaItemForm } from "./EditAgendaItemForm";

export const EditAgendaItemPanel: React.FC = () => {
  const i18n = useTranslations();
  const {
    confirmUnsaved,
    setConfirmUnsaved,
    editAgendaItemId,
    isDirty,
    isValid,
    isSubmitting,
    isSubmittable,
    getPatch,
    handleSave,
    handleClose,
    form,
  } = useEditAgendaItem();

  if (editAgendaItemId <= 0) {
    return null;
  }

  const saveButtonDisabled = !isDirty || !isValid;

  return (
    <>
      <SlidingPanel
        isOpen={true}
        size={50}
        onCancel={() => handleClose(true)}
        onSave={() => handleSave()}
        onClose={() => handleClose()}
        panelClassName="edit-agenda-item-panel panel-form"
        panelContainerClassName=""
        saveButtonDisabled={saveButtonDisabled}
        isSubmitting={isSubmitting}
        header={<h1>{i18n.EditAgendaItemPanel_Header}</h1>}
        footer={
          <EditFormFooter
            onCancel={() => handleClose(true)}
            onSubmit={() => handleSave()}
            isSubmitting={isSubmitting}
            isDirty={isDirty}
          />
        }
        debugContent={
          <HookFormDebug
            watch={() => getPatch(form.watch())}
            formState={form.formState}
            isSubmitting={isSubmitting}
            isSubmittable={isSubmittable}
          />
        }
      >
        <EditAgendaItemForm />
      </SlidingPanel>

      <ConfirmUnsaved
        onAccept={() => handleClose(true)}
        isOpen={confirmUnsaved}
        setIsOpen={setConfirmUnsaved}
        onCancel={() => setConfirmUnsaved(false)}
      />
    </>
  );
};
